module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "dedication"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("TO THE INDISPENSABLE:")]), _vm._v(" "), _c('p', {
    staticClass: "dedication1"
  }, [_vm._v("Cory Doctorow, Phyllis Gotlieb, Sally McBride,"), _c('br'), _vm._v("David Nickle, Helen Rykens, Sara Simmons,"), _c('br'), _vm._v("Michael Skeet, Hugh A. D. Spencer, Dale Sproule,"), _c('br'), _vm._v("Allan Weiss, and Theresa Wojtasiewicz"), _c('a', {
    attrs: {
      "id": "page_8"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-561e2c79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/dedication.vue
// module id = 81
// module chunks = 0